module.exports = __webpack_public_path__ + "static/enterprise_head-a76107a88f0d4bf3260cf7d03fa5ead4.png";